<template>
  <div>
    <PageHeader :items="items" />
    <div class="card">
      <div class="card-header">
        <h3>{{ $t("caseInformation") }}</h3>
      </div>
      <div class="card-body">
        <b-row>
          <b-col lg="6" md="6" cols="12" class="mb-1">
            <TextInput
              v-model="form.name"
              :label="$t('caseName')"
              :tooltipMessage="$t('name')"
              :disabled="true"
            />
          </b-col>
          <b-col lg="6" md="6" cols="12" class="mb-1">
            <div class="form-group">
              <label class="input-label form-label">{{ $t("status") }} </label>
              <multiselect
                v-model="form.status"
                :disabled="true"
                :options="[
                    'created',
                    'processing',
                    'reviewing',
                    'adjusting',
                    'done'
                  ]"
                :multiple="false"
              >
              </multiselect>
            </div>
          </b-col>
          <b-col lg="6" md="6" cols="12" class="mb-1">
              <div class="form-group">
                  <label class="input-label form-label"
                  >{{ $t("outcome") }}
                  </label>
                  <multiselect
                      v-model="form.outcome"
                      :options="[
                        'success',
                        'error',
                        'rejected'
                      ]"
                      :disabled="true"
                      :multiple="false"
                  >
                  </multiselect>
              </div>
            </b-col>

          <b-col lg="6" md="6" cols="12" class="mb-1">
            <div class="form-group">
              <label class="input-label form-label">{{ $t("company") }} </label>
              <div class="form-control disabled">
                {{ companyName }}
              </div>
            </div>
          </b-col>
          <b-col lg="6" md="6" cols="12" class="mb-1">
            <label class="form-label" for="cars">{{ $t("sender") }}</label>
            <div class="form-control disabled">
              <p v-if="caseUser">
                {{ caseUser.first_name }}
                <span>{{ caseUser.last_name }}</span>
              </p>
            </div>
          </b-col>
          <b-col lg="6" md="6" cols="12" class="mb-1">
            <label class="form-label" for="cars">{{ $t("senderMail") }}</label>
            <div class="form-control disabled">
              <p v-if="caseUser">
                <a :href="'mailto:' + caseUser.email">{{ caseUser.email }}</a>
              </p>
            </div>
          </b-col>
          <b-col lg="6" md="6" cols="12" class="mb-1">
            <label class="form-label" for="cars">{{
              $t("contactLanguage")
            }}</label>
            <div class="form-control disabled">
              <p>
                {{ contactLanguage }}
              </p>
            </div>
          </b-col>
          <b-col lg="6" md="6" cols="12" class="mb-1" v-if="productName">
            <label class="form-label" for="cars">{{ $t("productName") }}</label>
            <div class="form-control disabled">
              <p>
                {{ translatedProductName(productName) }}
              </p>
            </div>
          </b-col>
          <b-col lg="6" md="6" cols="12" class="mb-1">
            <label class="form-label" for="cars">{{ $t("modality") }}</label>
            <div class="form-control disabled">
              <p>
                {{ form.modality }}
              </p>
            </div>
          </b-col>
          <b-col lg="6" md="6" cols="12" class="mb-1">
            <label class="form-label" for="cars">{{
              $t("technology")
            }}</label>
            <div class="form-control disabled">
              <p>
                {{ technology }}
              </p>
            </div>
          </b-col>
          <b-col lg="6" md="6" cols="12" class="mb-1">
            <TextInput
              :type="'number'"
              v-model="form.noOfUnits"
              :label="$t('noOfUnits')"
              :tooltipMessage="$t('noOfUnits')"
              :disabled="true"
            />
          </b-col>
          <b-col lg="3" md="3" cols="12" class="mb-1">
            <div class="checkbox-group d-inline-block mt-2">
              <input
                :disabled="true"
                id="isApproved"
                class="checkbox-input"
                v-model="form.isApproved"
                type="checkbox"
                name="isApproved"
              />
              <label class="checkbox-label" for="isApproved">{{
                $t("approved")
              }}</label>
            </div>
          </b-col>
          <b-col lg="3" md="3" cols="12" class="mb-1">
            <div class="checkbox-group d-inline-block mt-2">
              <input
                id="isPaid"
                :disabled="true"
                class="checkbox-input"
                v-model="form.isPaid"
                type="checkbox"
                name="isPaid"
              />
              <label class="checkbox-label" for="isPaid">{{
                $t("isPaid")
              }}</label>
            </div>
          </b-col>
          <b-col lg="3" md="3" cols="12" class="mb-1">
            <div class="checkbox-group d-inline-block mt-2">
              <input
                id="jawsCorrectlyAligned"
                class="checkbox-input"
                :disabled="true"
                v-model="form.jawsCorrectlyAligned"
                type="checkbox"
                name="jawsCorrectlyAligned"
              />
              <label class="checkbox-label" for="jawsCorrectlyAligned">{{
                $t("wasTheBiteAlsoScanned")
              }}</label>
            </div>
          </b-col>
          <b-col lg="12" md="12" cols="12" class="mb-1">
            <label class="input-label form-label">
              {{ $t("comments") }}
            </label>
            <textarea
              :disabled="true"
              class="form-control"
              v-model="form.details"
            ></textarea>
          </b-col>
          <b-col lg="12" md="12" cols="12" class="">
            <label class="input-label form-label">
              {{ $t("commentForNotificationMail") }}
            </label>
            <textarea
              :disabled="true"
              class="form-control"
              v-model="form.notificationMailComment"
            ></textarea>
          </b-col>
          <b-col
            lg="6"
            md="6"
            cols="12"
            class="mb-1 mt-3"
            v-if="form.results && form.results['upper_image']"
          >
            <div v-if="form.results && form.results['upper_image']" class="">
              <h4>{{ $t("upperJawRating") }}</h4>
              <StarRating
                :readonly="true"
                :value="(form.ratings && form.ratings.upper_case_rating) || 0"
              />
            </div>
          </b-col>
          <b-col
            lg="6"
            md="6"
            cols="12"
            class="mb-1 mt-3"
            v-if="form.results && form.results['lower_image']"
          >
            <div v-if="form.results && form.results['lower_image']" class="">
              <h4>{{ $t("lowerJawRating") }}</h4>
              <StarRating
                :readonly="true"
                :value="(form.ratings && form.ratings.lower_case_rating) || 0"
              />
            </div>
          </b-col>
        </b-row>
      </div>
    </div>
    <div v-if="productName=='dentaBridge'" class="card">
      <div class="card-header">
        <h3>{{ $t("dentaBridgeSpecifications") }}</h3>
      </div>
      <div class="card-body">
        <b-row>
          <b-col cols="4">
            <TextInput :label="$t('material')" :value="getMaterialName(material)" :isReadonly="true" />
          </b-col>
          
          <b-col cols="4">
            <TextInput :label="$t('cementGap')" :value="dentaBridgeSpecifications.cementGap" :isReadonly="true" />
          </b-col>
          <b-col cols="4">
            <TextInput :label="$t('startCementGap')" :value="dentaBridgeSpecifications.startCementGap != null ? Number(dentaBridgeSpecifications.startCementGap).toFixed(2) : ''" :isReadonly="true" />
          </b-col>
          <b-col cols="4">
            <TextInput :label="$t('edgeThickness')" :value="dentaBridgeSpecifications.edgeThickness != null ? Number(dentaBridgeSpecifications.edgeThickness).toFixed(2) : ''" :isReadonly="true" />
          </b-col>
          <b-col cols="4">
            <TextInput :label="$t('minimumThickness')" :value="dentaBridgeSpecifications.minimumThickness != null ? Number(dentaBridgeSpecifications.minimumThickness).toFixed(2) : ''" :isReadonly="true" />
          </b-col>
          <b-col v-if="dentaBridgeSpecifications.manufacturingMethod === 'milling'" cols="4">
            <TextInput :label="$t('millingHeadDiameter')" :value="dentaBridgeSpecifications.millingHeadDiameter" :isReadonly="true" />
          </b-col>
          <b-col v-if="dentaBridgeSpecifications.manufacturingMethod === 'milling'" cols="4">
            <TextInput :label="$t('occlusalContactStrength')" :value="dentaBridgeSpecifications.occlusalContactStrength != null ? Number(dentaBridgeSpecifications.occlusalContactStrength).toFixed(3) : ''" :isReadonly="true" />
          </b-col>
          <b-col v-if="dentaBridgeSpecifications.manufacturingMethod === 'milling'" cols="4">
            <TextInput :label="$t('proximalContactStrength')" :value="dentaBridgeSpecifications.proximalContactStrength != null ? Number(dentaBridgeSpecifications.proximalContactStrength).toFixed(3) : ''" :isReadonly="true" />
          </b-col>
          <b-col cols="4">
            <TextInput :label="$t('gingivalContactStrength')" :value="dentaBridgeSpecifications.gingivalContactStrength != null ? Number(dentaBridgeSpecifications.gingivalContactStrength).toFixed(3) : ''" :isReadonly="true" />
          </b-col>
          <!-- <b-col cols="4"> <SegmentedRadio v-model="dentaBridgeSpecifications.mode" :label="$t('millingOrPrinting')"  :options="[$t('left'), $t('right')]" :readonly="true" /> </b-col> -->
          <b-col cols="4">
            <SegmentedRadio ref="manufacturingMethodRadio" v-model="dentaBridgeSpecifications.manufacturingMethod" :label="$t('manufacturingMethod')" :options="[$t('milling'),$t('printing')]" :optionValues="['milling', 'printing']" :readonly="true" />
          </b-col>
          <!-- <b-col cols="4" v-if="dentaBridgeSpecifications.manufacturingMethod === 'milling'">
            <TextInput :label="$t('millingHeadSize')" :value="dentaBridgeSpecifications.millingHeadSize" :isReadonly="true" />

          </b-col> -->
        </b-row>
      </div>
    </div>
    <b-row>
      <b-col md="12">
        <PreviewOriginalModel
          ref="previewOriginalRef"
          v-if="renderOriginalComponent"
          :isShow="true"
          :upperFileId="form.files.upper"
          :lowerFileId="form.files.lower"
          :downloadUpper="form.files.upper_portal_original"
          :downloadLower="form.files.lower_portal_original"
          :upperMatrixIn="
            form.files.upper_matrixLocal && form.files.upper_matrixLocal.reg
          "
          :upperMatrixWorldIn="
            form.files.upper_matrixWorld && form.files.upper_matrixWorld.reg
          "
          :lowerMatrixIn="
            form.files.lower_matrixLocal && form.files.lower_matrixLocal.reg
          "
          :lowerMatrixWorldIn="
            form.files.lower_matrixWorld && form.files.lower_matrixWorld.reg
          "
          :markedTeeth="markedTeeth"
          :toggledPairs="toggledPairs"
          :productName="productName"
          :teethFile="teethFile"
        />
      </b-col>
    </b-row>
    <div class="card">
      <div class="card-header">
        <h3>{{ $t("caseFiles") }}</h3>
      </div>
      <div class="row" v-if="form.constructionFile && form.constructionFile.fileId">
        <div class="col-md-6">
          <div class="card-header">
            <h3 class="card-title">{{ $t("constructionInfo") }}</h3>
          </div>
          <div class="card-body">
            <div class="upload-file-list">
              <ul>
                <li>
                  <h4>
                    {{ form.constructionFile.fileName || $t("constructionInfo") }}
                  </h4>
                  <div class="action-buttons d-flex justify-content-end gap-2">
                    <button
                      class="btn btn-sm btn-outline-secondary d-flex align-items-center gap-2"
                      @click="downloadFiles([form.constructionFile.fileId])"
                    >
                      <feather-icon size="16" icon="DownloadIcon" />
                      <span>{{ $t("download") }}</span>
                    </button>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div
          v-if="form.files.upper_portal_original || form.files.upper_portal"
          class="col-md-6"
        >
          <div class="card-header">
            <h3 class="card-title">{{ $t("upperJaw") }}</h3>
          </div>
          <div class="card-body">
            <div class="upload-file-list">
              <ul>
                <li
                  v-for="(fileItem, index) in upperJawFiles"
                  :key="index"
                  v-if="getFileValue(fileItem.source, fileItem.key)"
                >
                  <h4>
                    {{ fileItem.label
                    }}<span v-if="fileItem.key === 'upper_rotated'">
                      {{ isUpperResultActive ? "ACTIVE" : "INACTIVE" }}
                    </span>
                  </h4>
                  <div class="action-buttons d-flex justify-content-end gap-2">
                    <button
                      class="btn btn-sm btn-outline-primary d-flex align-items-center gap-2"
                      @click="
                        handlePreviewResultClick(
                          [getFileValue(fileItem.source, fileItem.key)],
                          'Upper'
                        )
                      "
                    >
                      <feather-icon size="16" icon="EyeIcon" />
                      <span>{{ $t("preview") }}</span>
                    </button>

                    <button
                      class="btn btn-sm btn-outline-secondary d-flex align-items-center gap-2"
                      @click="
                        downloadFiles([
                          getFileValue(fileItem.source, fileItem.key),
                        ])
                      "
                    >
                      <feather-icon size="16" icon="DownloadIcon" />
                      <span>{{ $t("download") }}</span>
                    </button>
                  </div>
                </li>
                <li v-for="(fileItem, index) in upperCaseResults" :key="index">
                  <h4>
                    {{ fileItem.fileName }}
                    {{ fileItem.isActive ? "ACTIVE" : "INACTIVE" }}
                  </h4>
                  <div class="action-dropdown">
                    <div
                      class="action-buttons d-flex justify-content-end gap-2"
                    >
                      <button
                        class="btn btn-sm btn-outline-primary d-flex align-items-center gap-2"
                        @click="
                          handlePreviewResultClick([fileItem.fileId], 'Upper')
                        "
                      >
                        <feather-icon size="16" icon="EyeIcon" />
                        <span>{{ $t("preview") }}</span>
                      </button>

                      <button
                        class="btn btn-sm btn-outline-secondary d-flex align-items-center gap-2"
                        @click="downloadFiles([fileItem.fileId])"
                      >
                        <feather-icon size="16" icon="DownloadIcon" />
                        <span>{{ $t("download") }}</span>
                      </button>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div
          v-if="form.files.lower_portal_original || form.files.lower_portal"
          class="col-md-6"
        >
          <div class="card-header">
            <h3 class="card-title">{{ $t("lowerJaw") }}</h3>
          </div>
          <div class="card-body">
            <div class="upload-file-list">
              <ul>
                <li
                  v-for="(fileItem, index) in lowerJawFiles"
                  :key="index"
                  v-if="getFileValue(fileItem.source, fileItem.key)"
                >
                  <h4>
                    {{ fileItem.label
                    }}<span v-if="fileItem.key === 'lower_rotated'">
                      {{ isLowerResultActive ? "ACTIVE" : "INACTIVE" }}
                    </span>
                  </h4>
                  <div class="action-buttons d-flex justify-content-end gap-2">
                    <button
                      class="btn btn-sm btn-outline-primary d-flex align-items-center gap-2"
                      @click="
                        handlePreviewResultClick(
                          [getFileValue(fileItem.source, fileItem.key)],
                          'Lower'
                        )
                      "
                    >
                      <feather-icon size="16" icon="EyeIcon" />
                      <span>{{ $t("preview") }}</span>
                    </button>

                    <button
                      class="btn btn-sm btn-outline-secondary d-flex align-items-center gap-2"
                      @click="
                        downloadFiles([
                          getFileValue(fileItem.source, fileItem.key),
                        ])
                      "
                    >
                      <feather-icon size="16" icon="DownloadIcon" />
                      <span>{{ $t("download") }}</span>
                    </button>
                  </div>
                </li>
                <li v-for="(fileItem, index) in lowerCaseResults" :key="index">
                  <h4>
                    {{ fileItem.fileName }}
                    {{ fileItem.isActive ? "ACTIVE" : "INACTIVE" }}
                  </h4>
                  <div class="action-dropdown">
                    <b-nav-item-dropdown
                      right
                      toggle-class="d-flex align-items-center"
                    >
                      <template #button-content>
                        <div>
                          <ElementIcon icon="barVerticalIcon" />
                        </div>
                      </template>
                      <b-dropdown-item
                        @click="
                          handlePreviewResultClick([fileItem.fileId], 'Lower')
                        "
                        link-class="d-flex align-items-center gap-2"
                      >
                        <feather-icon size="16" icon="EyeIcon" />
                        <span>{{ $t("preview") }}</span>
                      </b-dropdown-item>
                      <b-dropdown-item
                        @click="downloadFiles([fileItem.fileId])"
                        link-class="d-flex align-items-center gap-2"
                      >
                        <feather-icon size="16" icon="DownloadIcon" />
                        <span>{{ $t("download") }}</span>
                      </b-dropdown-item>
                    </b-nav-item-dropdown>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="card">
      <UploadHistory ref="uploadHistoryRef" />
    </div> -->
    <div class="card">
      <Logs />
    </div>
    <div class="d-flex align-items-center justify-content-end gap-2">
      <router-link
        to="/my-cases"
        class="d-flex align-items-center gap-1 btn btn-secondary"
      >
        <feather-icon icon="XIcon" size="12" />
        <span>{{ $t("cancel") }}</span>
      </router-link>
      <b-button
        variant="primary"
        @click="sendMail()"
        class="d-flex align-items-center gap-1"
      >
        <feather-icon icon="PlusIcon" size="12" />
        <span>{{ $t("sendApprovedNotificationMail") }}</span>
      </b-button>
    </div>
    <div class="c-modal" v-show="showPreviewModal">
      <div class="c-modal-content">
        <div class="c-modal-header">
          <h3>{{ $t(previewJawType === 'upper' ? 'previewUpperJaw' : 'previewLowerJaw') }}</h3>
          <div class="x-icon" @click="closePreviewResultModal">
            <feather-icon size="16" icon="XIcon" />
          </div>
        </div>
        <div class="c-modal-body">
          <PreviewResultModel v-if="showPreviewModal" :results="file" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as THREE from "three";
import TextInput from "@/components/TextInput.vue";
import PageHeader from "@/components/PageHeader.vue";
import Multiselect from "vue-multiselect";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapGetters } from "vuex";
import { VueEditor } from "vue2-quill-editor";
import { required, email } from "@validations";
import StarRating from "@/components/elements/StarRating.vue";
import PreviewResultModel from "@/components/PreviewResultModel.vue";
import FileService from "@/services/file.service";
import PreviewOriginalModel from "./components/PreviewOriginalModel.vue";
import Logs from "./components/Logs.vue";
import UploadHistory from "./components/UploadHistory.vue";
import ElementIcon from "@/components/elements/Icon.vue";
import SegmentedRadio from "@/components/elements/SegmentedRadio.vue";
import materialNameMixin from "@/mixins/materialNameMixin";

export default {
  components: {
    TextInput,
    PageHeader,
    Multiselect,
    ValidationProvider,
    ValidationObserver,
    VueEditor,
    StarRating,
    PreviewResultModel,
    PreviewOriginalModel,
    Logs,
    UploadHistory,
    ElementIcon,
    SegmentedRadio,
  },
  mixins: [materialNameMixin],
  computed: {
    ...mapGetters("globalConfiguration", ["configuration"]),
    ...mapGetters("caseLists"),
    ...mapGetters("auth", ["user"]),
    items() {
      return [
        {
          text: "Dental Twin",
          to: "/home",
        },
        {
          text: this.$t("cases"),
          to: "/my-cases",
        },
        {
          html: `${this.$t("show")}${this.form.name ? ' <strong>[' + this.form.name + ']</strong>' : ''}`,
          active: true,
        },
      ];
    },
  },
  data() {
    return {
      upperFiles: [],
      lowerFiles: [],
      markedTeeth: [],
      toggledPairs: [],
      isUpperResultActive: true,
      isLowerResultActive: true,
      teethFile: "",
      upperJawFiles: [
        {
          key: "upper_portal_original",
          label: "original.stl",
          source: "files",
        },
        {
          key: "upper_portal",
          label: "original registered.stl",
          source: "files",
        },
        { key: "upper", label: "original used for AI.stl", source: "files" },
        { key: "upper_rotated", label: "result.stl", source: "results" },
        { key: "upper", label: "result deregistered.stl", source: "results" },
      ],
      lowerJawFiles: [
        {
          key: "lower_portal_original",
          label: "original.stl",
          source: "files",
        },
        {
          key: "lower_portal",
          label: "original registered.stl",
          source: "files",
        },
        { key: "lower", label: "original used for AI.stl", source: "files" },
        { key: "lower_rotated", label: "result.stl", source: "results" },
        { key: "lower", label: "result deregistered.stl", source: "results" },
      ],
      upperCaseResults: [],
      lowerCaseResults: [],
      technology: "",
      form: {
        name: "",
        details: "",
        status: "",
        outcome: "",
        results: {},
        ratings: {},
        files: {},
        isApproved: false,
        jawsCorrectlyAligned: false,
        isPaid: false,
        notificationMailComment: "",
        modality: "",
        noOfUnits: "",
        constructionFile: null,
      },
      productName: "",
      material: {},
      showMultipleUploadModal: false,
      isPaid: false,
      caseUser: {},
      companyName: "",
      contactLanguage: "",
      showPreviewModal: false,
      file: null,
      previewJawType: "",
      renderOriginalComponent: false,
      caseId: "",
      dentaBridgeSpecifications: {
        material: "",
        cementGap: 0,
        startCementGap: 0,
        edgeThickness: 0,
        minimumThickness: 0,
        millingHeadDiameter: 0,
        occlusalContactStrength: 0,
        proximalContactStrength: 0,
        gingivalContactStrength: 0,
        // mode: "left",
        manufacturingMethod: "milling",
        // millingHeadSize: 1,
      },
    };
  },
  async mounted() {
    this.caseId = this.$route.params.id;
    await this.loadItems();
    await this.loadResults();

    this.$store.commit("showLoader", false);
  },
  methods: {
    getFileValue(source, key) {
      return this.form[source] && this.form[source][key]
        ? this.form[source][key]
        : null;
    },
    async loadResults() {
      try {
        this.$store.commit("showLoader", true);
        let response = await this.$store.dispatch(
          "caseLists/getMultipleResults",
          {
            id: this.$route.params.id,
          }
        );
        const responseData = response?.data?.data ?? [];

        this.upperCaseResults = responseData.filter(
          (item) => item.type === "Upper Jaw Result"
        );
        this.isUpperResultActive = !this.upperCaseResults.some(
          (item) => item.isActive == true
        );
        this.lowerCaseResults = responseData.filter(
          (item) => item.type === "Lower Jaw Result"
        );
        this.isLowerResultActive = !this.lowerCaseResults.some(
          (item) => item.isActive == true
        );
      } catch (e) {
        console.error("api error ___", e);
      } finally {
        this.$store.commit("showLoader", false);
      }
    },
    async sendMail() {
      try {
        this.$store.commit("showLoader", true);
        await this.$store
          .dispatch("caseLists/sendMail", this.$route.params.id)
          .finally(() => {
            this.$store.commit("showLoader", false);
          });
      } catch (e) {
        this.$store.commit("showLoader", false);
        console.error("api error", e);
      }
    },
    async loadItems() {
      this.renderOriginalComponent = false;
      await this.$store
        .dispatch("caseLists/show", {
          id: this.$route.params.id,
          isShow: true,
        })
        .then(async (res) => {
          var response = res?.data?.data;
          this.companyName = response?.companyName ?? "-";
          this.form.name = response?.name ?? "";
          this.form.noOfUnits = response?.noOfUnits ?? "";
          this.productName = response?.productName ?? "";
          this.form.notificationMailComment =
            response?.notificationMailComment ?? "";
          this.contactLanguage = response?.contactLanguage ?? "";
          this.form.modality = response?.modality ?? "";          
          this.technology = response?.technology ?? "";
          this.material = response?.material ?? {};

          this.teethFile = response?.teethFile ?? "";
          this.dentaBridgeSpecifications = response?.dentaBridgeSpecifications ?? {
            material: "",
            cementGap: 0,
            startCementGap: 0,
            edgeThickness: 0,
            minimumThickness: 0,
            // mode: "left",
            millingHeadDiameter: 0,
            occlusalContactStrength: 0,
            proximalContactStrength: 0,
            gingivalContactStrength: 0,
            manufacturingMethod: "milling",
            millingHeadSize: 1,
          };
          this.form.details = response?.details ?? "";
          this.form.status = response?.status ?? "";
          this.form.outcome = response?.outcome ?? "";
          this.form.results = response?.results ?? {};
          this.form.ratings = response?.ratings ?? {};
          this.form.files = response?.files ?? {};
          this.form.constructionFile = response?.constructioninfoFile ?? null;
          this.form.isApproved = response?.isApproved;
          this.form.jawsCorrectlyAligned = response?.jawsCorrectlyAligned;
          this.form.isPaid = response?.isPaid;
          this.markedTeeth = response?.markedTeeth?.selectedTeeth ?? [];
          this.toggledPairs = response?.markedTeeth?.connectedTeeth ?? [];
          this.isPaid = response?.isPaid;
          await this.$store
            .dispatch("auth/showUser", {
              id: response?.user_id,
            })
            .then(async (res) => {
              this.caseUser = res?.data ?? {};
            });
        });
      this.renderOriginalComponent = true;
    },
    downloadFiles(array) {
      FileService.downloadFiles(array, this.$store);
    },
    closePreviewResultModal() {
      this.showPreviewModal = false;
    },
    handlePreviewResultClick(array, jawType) {
      this.file = array;
      this.previewJawType = jawType;
      this.showPreviewModal = true;
    },
  },
};
</script>

<style lang="scss" scoped>
#nprogress {
  position: relative;
  z-index: 9999999;
}

.white-color {
  color: white !important;
}

.vgt-responsive {
  overflow-x: visible !important;
}

.news-image {
  margin-top: 10px;
  img {
    width: 200px;
    max-width: 100%;
    object-fit: contain;
    border: 1px solid rgba(255, 255, 255, 0.2);
    padding: 5px;
    border-radius: 5px;
  }
}

// .page-header {
//   position: sticky !important;
//   top: 10px !important;
//   z-index: 1000 !important;
// }
</style>
